module.exports = __webpack_public_path__ + "img/jypx-4.96123a2f.webp";